// src/jira/issue-status/types.ts
var JiraIssueStatusAriResourceOwner = "jira", JiraIssueStatusAriResourceType = "issue-status";

export {
  JiraIssueStatusAriResourceOwner,
  JiraIssueStatusAriResourceType
};
